





<mat-card class="details" *ngIf="showScreen">
  <table style="width: 100%; height: 100%">
    <tr>

      <td class="topTd" >

        <table style="width: 100%; border-collapse: collapse;margin: 0px; padding: 0px">
          <tr>
            <td style="width: 1%">
              <div class="maher" (click)="leaveScreen()"></div>
            </td>
            <td style="width: 30%; text-align: left">
              <div class="titleFont" style="font-size: 23px; padding-left: 0%; text-align: -webkit-left">Email/Reports</div>
            </td>
            <td style="width: 70%"></td>
          </tr>
        </table>


        <div class="flex-item2" >

          <mat-table #table23 style="width:100%" [dataSource]="emailReportData" multiTemplateDataRows matSort="container"  >


            <ng-container matColumnDef="report" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Report</mat-header-cell>
              <mat-cell *matCellDef="let row" style="font-family: almoni; font-size: 18px">{{row.report_description}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="email" >

              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Email Address</mat-header-cell>

              <mat-cell *matCellDef="let row" >
                <input [(ngModel)]="row.email_address" (keydown)="validEmail(row)" (change)="validEmail(row)" matInput  style="vertical-align: super; border: black 1px solid;  min-height: 24px; min-width: 99%; background-color: white; font-size: 19px; font-family: almoni; font-weight: 900 ">
               <mat-icon matSuffix *ngIf="row.invalidEmail" style="margin-top: 4px; position: absolute; right: 366px"><img style="height: 21px;"  src="assets/troubleRed.png" ></mat-icon>
              </mat-cell>

            </ng-container>
            <ng-container matColumnDef="format" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Format</mat-header-cell>
              <mat-cell  *matCellDef="let row" style="justify-content: left; padding-bottom: 1px" >

                <mat-select  [(value)]="row.attachment_type_code" style="vertical-align: super; border: black 1px solid; min-height: 24px; max-width: 64%; background-color: white; " >
                  <mat-option  *ngFor="let lr of formatsArray" [value]="lr.code" style="min-height: 24px; font-weight: 900; font-family: almoni; font-size: 18px">{{lr.description}}</mat-option>
                </mat-select>



                <span style="padding-left: 10%"></span>
                <mat-icon matPrefix style="padding-bottom: 5px" (click)="insertUpdateEmailReportAddress('D',row)"><img style="vertical-align: center;height:36px; width: 36px" src="assets/delete-24px.svg" ></mat-icon>
                <span style="padding-left: 10%"></span>

                <mat-icon matPrefix (click)="insertUpdateEmailReportAddress('U', row)"><img style="vertical-align: center;height:30px; width: 29px" src="assets/greenCheck.png" ></mat-icon>

              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="cColumns; sticky: true"></mat-header-row>
            <mat-row   *matRowDef="let row; columns: cColumns;" class="table-row"></mat-row>
          </mat-table>

          <mat-toolbar style="width: 100%; display: unset">
            <mat-toolbar-row style="width: 100%; justify-content: center">
              <mat-paginator class="myPaginator"  [pageSize]="20" [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
            </mat-toolbar-row>
          </mat-toolbar>

        </div>
      </td>
      <td class="loginPic" style="">

      </td>
    </tr>
  </table>
</mat-card>
